import { CommitProps } from "../state/types";
import { CommitCell } from "./CommitCell";

type Props = {
  commits: CommitProps[],
}

export function CommitColumn({ commits }: Props) {
  return <div class="commit">
    {commits.map(c => {
      return <CommitCell {...c}></CommitCell>;
    })}
  </div>;
}
